/** A patient's age and sex as a short phrase — the one rule the list and the session page share. */

/** `24, "male"` → `24 yrs · Male`; an unknown age or an "other" sex is left out. */
export function patientDetails(age: number, sex: string, separator = " · "): string {
  const parts: string[] = [];
  if (age > 0) parts.push(`${age} yrs`);
  if (sex && sex !== "other") parts.push(sex.charAt(0).toUpperCase() + sex.slice(1));
  return parts.join(separator);
}

/**
 * The patient's introduction as the voice model recorded it: `"Mark", 28, "male"` →
 * `Mark, 28, male`. `null` when nothing was recorded ("Unknown" is the report's placeholder).
 */
export function introduction(name: string, age: number, sex: string): string | null {
  const parts: string[] = [];
  const cleanName = name.trim();
  if (cleanName !== "" && cleanName.toLowerCase() !== "unknown") parts.push(cleanName);
  if (age > 0) parts.push(String(age));
  if (sex.trim() !== "") parts.push(sex.trim().toLowerCase());
  return parts.length === 0 ? null : parts.join(", ");
}
